import Column from '@components/Column';
import Row from '@components/Row';
import Text from '@components/Text';
import { Link } from '@stackflow/link';
import { useTranslation } from 'react-i18next';

import styles from './styles.module.scss';

function SignUpText() {
    const { t } = useTranslation('signIn');
    return (
        <Column className={styles.container}
            align='center'
            fullWidth
            spacing={12}>
            <Row spacing={56} fullWidth>
                <div className={styles.line} />
                <Text size='lg'>{t('or')}</Text>
                <div className={styles.line} />
            </Row>
            <Link activityName='SignUpActivity'
                activityParams={{}}>
                <Text size='lg' fontWeight='bold'>
                    {t('signUp')}
                </Text>
            </Link>
        </Column>
    );
}

export default SignUpText;
